import { useEffect, useState } from 'react';
import { TablePaginationConfig } from 'antd';
import { OrderManagementQueryParams, useOrders } from 'hooks/OrderManagement/useOrders';

export const useOrderHelper = (props: OrderManagementQueryParams = {}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    // pageSize: data?.meta?.limit,
    // total: data?.meta?.totalDocs,
  });

  const { data, isPending: isLoading } = useOrders({
    ...props,
    status: props.status ? props.status?.toLowerCase() : undefined,
    page: pagination.current,
  });

  useEffect(() => {
    if (data) {
      setPagination((prev) => ({
        ...prev,
        pageSize: data.meta?.limit || 15,
        total: data.meta?.totalDocs,
      }));
    }
  }, [data?.meta?.limit, data?.meta?.totalDocs]);

  useEffect(() => {
    if (props?.startDate||props?.endDate||props?.status||props?.search) {
      setPagination((prev) => ({
        ...prev,
        current: 1
      }));
    }
  }, [props?.startDate, props?.endDate, props?.status, props?.search]);

  // const handleTableChange: TableProps<DataType>['onChange'] = (pagination, filters, sorter) => {
  //   setTableParams({
  //     pagination,
  //     filters,
  //     sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
  //     sortField: Array.isArray(sorter) ? undefined : sorter.field,
  //   });

  //   // `dataSource` is useless since `pageSize` changed
  //   if (pagination.pageSize !== tableParams.pagination?.pageSize) {
  //     setData([]);
  //   }
  // };

  const handleTableChange = (newPagination: TablePaginationConfig) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current ?? 1,
      pageSize: newPagination.pageSize ?? 15,
    }));
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  

  return {
    isModalOpen,
    pagination,
    data,
    rowSelection,
    isLoading,
    showModal,
    handleTableChange,
    handleModalClose,
  };
};
